import React, { FunctionComponent } from 'react';

import { TextAreaFieldType } from '../../types';
import { TextField } from '.';

const TextAreaField: FunctionComponent<TextAreaFieldType> = ({ rows = 5, ...props }) => {
  return (
    <TextField
      {...props}
      {...{
        component: 'textarea',
        rows: rows,
      }}
    />
  );
};

export default TextAreaField;
